module.exports = __webpack_public_path__ + "static/media/ak.fbedeba1.svg";